import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import ReactPlayer from 'react-player';

const StyledContainer = styled.div`
  display: block;
  padding-bottom: ${props => (1 / props.aspectRatio) * 100}%;
  position: relative;
  width: 100%;

  > :first-child {
    bottom: 0;
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
  }
`;

const ExternalMediaPlayer = ({ mediaUrl, aspectRatio = 16 / 9, load = true }) => {
  return (
    <StyledContainer aspectRatio={aspectRatio}>
      {load && <ReactPlayer url={mediaUrl} width="100%" height="100%" controls />}
    </StyledContainer>
  );
};

ExternalMediaPlayer.propTypes = {
  mediaUrl: PropTypes.string.isRequired,
  aspectRatio: PropTypes.number,
  load: PropTypes.bool,
};

export default ExternalMediaPlayer;
